import { type CalculatedTime, calculateTimeBySeconds, moment } from "../date";
import type { AttendanceList } from "../types";

export function calculateAttendancesTime(attendances: AttendanceList): CalculatedTime {
	let seconds = 0;

	for (const attendance of attendances) {
		if (attendance.state === "rejected") continue;
		if (!attendance.startTime) continue;
		if (!attendance.endTime) continue;
		seconds += Math.abs(moment(attendance.endTime).diff(moment(attendance.startTime), "seconds"));
	}

	return calculateTimeBySeconds(seconds);
}
